<span class="basic-badge" [class]="'basic-badge--' + variant()">{{ value() }}</span>
